export const FORM_OF_PAYMENT_CODE = {
  DINHEIRO: '01',
  CHEQUE: '02',
  CARTAO_CREDITO: '03',
  CARTAO_DEBITO: '04',
  CREDITO_LOJA: '05',
}
